<template>
  <div class="container-fluid overflow-auto page-container-h">
    <section class="statistical-area">
      <div
        v-for="(item, index) of statistical" :key="index"
        class="statistical-card"
        :style="styleTheme(item.theme)"
      >
        <div class="statistical-card-body">
          <div class="statistical-item">
            <div class="title primary">{{ item.title }}</div>

            <div :class="['content', {'link': item.is_link}]" @click="item.clickFunction">{{ item.value }}</div>
          </div>

          <div class="statistical-icon">
            <i :class="item.icon"></i>
          </div>
        </div>
      </div>
    </section>

    <!-- <b-alert class="remark mt-4" show variant="warning">
      <div class="text-weight-bold">互助費之結算</div>
      <div>一、互助費於每月結算及收取乙次。</div>
      <div>二、互助費之計算公式為：當期申請互助金人數乘以1,000除以當期有效會員數。</div>
      <div>三、前項之平均每千人申請互助金人數，採無條件進位個位數計算。</div>
    </b-alert> -->

    <!-- 假名單 modal -->
    <fake-list-modal
      v-model="status.fakeMutualListModal"
      :isMaskData="true"
      :plan="plan"
      :type="type"
      :title="title" />
  </div>
</template>

<script>
import reportApi from "@/models/API/reportApi";
import FakeListModal from "@/components/common/Modal/FakeListModal";

export default {
  name: 'ToHelpingOthersDashboard',
  components: {
    FakeListModal,
  },
  data () {
    return {
      status: {
         fakeMutualListModal: false
      },
      statistical: [
        // {
        //   id: 2,
        //   title: '永保上月新增人數',
        //   key: 'plan_A_add',
        //   value: 0,
        //   theme: 'primary',
        //   icon: 'fa-solid fa-folder-plus',
        //   sort: 3,
        //   is_link: true,
        //   clickFunction: () => this.openFakeListModal('A', 2, '新增名單')
        // },
        {
          id: 3,
          title: '永保當月互助人數',
          key: 'plan_A_effect',
          value: 0,
          theme: 'primary',
          icon: 'fa-solid fa-hands-holding-child',
          sort: 1,
          is_link: true,
          clickFunction: () => this.openFakeListModal('A', 0, '互助名單')
        },
        {
          id: 4,
          title: '永保上月辭世人數',
          key: 'plan_A_dead',
          value: 0,
          theme: 'primary',
          icon: 'fa-solid fa-user-injured',
          sort: 2,
          is_link: true,
          clickFunction: () => this.openFakeListModal('A', 1, '身故名單')
        },
        {
          id: 4,
          title: '永保額滿人數',
          key: 'plan_A_pay_off',
          value: 0,
          theme: 'primary',
          icon: 'fa-solid fa-money-bill-trend-up',
          sort: 4,
          is_link: true,
          clickFunction: () => this.openFakeListModal('A', 3, '額滿名單')
        },
        // {
        //   id: 5,
        //   title: '長安上月新增人數',
        //   key: 'plan_B_add',
        //   value: 0,
        //   theme: 'success',
        //   icon: 'fa-solid fa-folder-plus',
        //   sort: 7,
        //   is_link: true,
        //    clickFunction: () => this.openFakeListModal('B', 2, '新增名單')
        // },
        {
          id: 6,
          title: '長安當月互助人數',
          key: 'plan_B_effect',
          value: 0,
          theme: 'success',
          icon: 'fa-solid fa-hands-holding-child',
          sort: 5,
          is_link: true,
          clickFunction: () => this.openFakeListModal('B', 0, '互助名單')
        },
        {
          id: 7,
          title: '長安上月辭世人數',
          key: 'plan_B_dead',
          value: 0,
          theme: 'success',
          icon: 'fa-solid fa-user-injured',
          sort: 6,
          is_link: true,
          clickFunction: () => this.openFakeListModal('B', 1, '身故名單')
        },
        {
          id: 4,
          title: '長安額滿人數',
          key: 'plan_B_pay_off',
          value: 0,
          theme: 'success',
          icon: 'fa-solid fa-money-bill-trend-up',
          sort: 8,
          is_link: true,
          clickFunction: () => this.openFakeListModal('B', 3, '額滿名單')
        },
      ],
      plan: 'A',
      type: 0,
      title: '互助名單'
    }
  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.getReportMonthStatistical();
    },
    // 取得每月統計
    getReportMonthStatistical(params) {
      this.reportApi.getReportMonthStatistical((response) => {
        const res = response.data;
        const statistical_formatting = this.statistical.map(statistical_item => {
          return {
            ...statistical_item,
            value: res.data.find(item => item.name === statistical_item.key).value
          }
        });

        this.statistical = statistical_formatting.sort((a ,b) => a.sort - b.sort);
      }, params)
    },
    styleTheme(theme) {
      let color = '';

      switch (theme) {
        case 'primary':
          color = '#304ca1';
          break;
        case 'success':
          color = '#16a570';
          break;
        case 'info':
          color = '#36b9cc';
          break;
        default:
          color = '#304ca1';
          break;
      };

      return `--themeColor: ${color};`;
    },
    // 開啟假名單 modal
    openFakeListModal(plan = 'A', type = 0, title = '互助名單') {
      this.status.fakeMutualListModal = true;

      this.plan = plan;
      this.type = type;
      this.title = title;
    },
  }
}
</script>

<style lang="scss" scoped>
$themeColor: var(--themeColor);
.remark {
  font-size: 18px;
  .text-weight-bold {
    font-weight: bold;
  }
}

.statistical-area {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  .statistical-card {
    flex: 1 1 calc(33% - 20px);
    position: relative;
    display: flex;
    flex-direction: column;
    width: auto;
    min-height: 100px;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid #e3e6f0;
    border-radius: 0.35rem;
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
    border-left: 0.25rem solid $themeColor;
    .statistical-card-body {
      padding: 1.25rem;
      flex: 1 1 auto;
      display: flex;
        align-items: center;
        justify-content: space-between;
      .statistical-item {
        .title {
          font-weight: 700;
          font-size: 16px;
          color: $themeColor;
        }
        .content {
          font-weight: 700;
          font-size: 22px;
          color: #5a5c69;
        }
      }
      .statistical-icon {
        i {
          color: #dddfeb;
          font-size: 26px;
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .statistical-area {
    .statistical-card {
      flex: 1 1 calc(50% - 20px);
    }
  }
}

@media screen and (max-width: 576px) {
  .statistical-area {
    .statistical-card {
      flex: 1 1 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/toHelpingOthers/dashboard.vue